import styled from 'styled-components'

import { Heading } from '../../atoms'

// eslint-disable-next-line import/prefer-default-export
export const StyledHeading = styled(Heading).attrs(({ tag = '4', theme }) => ({
  tag,
  size: theme.typography.sizes.headings.h2,
}))``
